import { Instagram, Facebook, Linkedin } from "lucide-react";

export const COMPANY = {
  name: "Lutrom Engineering Ltd",
  legalName: "LUTROM ENGINEERING LIMITED",
  companyNumber: "13538846",
  registered: "Registered in England and Wales",
  address: {
    line1: "Unit 28 Winnington Business Park",
    line2: "Winnington Avenue",
    city: "Northwich",
    postcode: "CW8 4DL",
    country: "United Kingdom",
  },
  phone: {
    display: "+44 7599 474730",
    tel: "tel:+447599474730",
  },
  email: {
    display: "enquiries@lutrom.co.uk",
    mailto: "mailto:enquiries@lutrom.co.uk",
  },
  portal: "https://portal.lutrom.co.uk",
};

export const SOCIALS = [
  {
    name: "Instagram",
    href: "https://www.instagram.com/lutrom.engineering/",
    icon: Instagram,
    handle: "@lutrom.engineering",
  },
  {
    name: "Facebook",
    href: "https://m.facebook.com/profile.php?id=61553938456649",
    icon: Facebook,
    handle: "Lutrom Engineering",
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/88274339/",
    icon: Linkedin,
    handle: "Lutrom Engineering",
  },
];

export const addressLines = () => [
  COMPANY.address.line1,
  COMPANY.address.line2,
  `${COMPANY.address.city}, ${COMPANY.address.postcode}`,
];

export const addressInline = () =>
  `${COMPANY.address.line1}, ${COMPANY.address.line2}, ${COMPANY.address.city}, ${COMPANY.address.postcode}`;
